import Dialog   from "@mui/material/Dialog";
import ListMenu from "ui/components/dashboard-components/ListMenu";

const MobileMenu = (props: {
    open: boolean,
    handleClose: ()=>void
}) => {
    return(
        <Dialog
            open={props.open}
            onClose={props.handleClose}
        >
            <ListMenu callback={props.handleClose}/>
        </Dialog>
    );
};

export default MobileMenu;